export class Rectangle {
  public x: number;
  public y: number;
  public width: number;
  public height: number;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  public getRight(): number {
    return this.x + this.width;
  }

  public getBottom(): number {
    return this.y + this.height;
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/Rectangle.ts